import { useMutation } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";

export type AcceptInvitePayload = {
  token: string;
  firstName: string;
  lastName: string;
  password: string;
};

export const useAcceptInvite = () => {
  return useMutation({
    mutationFn: async (payload: AcceptInvitePayload) => {
      const res = await client.invitations.accept.$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
